export default __webpack_public_path__ + "static/media/s1.32910f51.jpg";